var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('v-card',{attrs:{"loading":_vm.isLoading}},[_c('v-card-title',[_vm._v("Kelon")]),_c('v-card-text',[_vm._v(_vm._s(_vm.group.title))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }